let hideTimeout
let removeTimeout

export function showToast(message, type = "notice") {
  const HIDE_DELAY = 3000
  const ANIMATION_DURATION = 300

  const container = document.querySelector('[data-toast-target="container"]')
  if (!container) return

  clearTimeout(hideTimeout)
  clearTimeout(removeTimeout)

  const noticeSection = container.querySelector('[data-toast-target="notice"]')
  const alertSection = container.querySelector('[data-toast-target="alert"]')
  const noticeMessage = container.querySelector('[data-toast-target="message"]')
  const alertMessage = container.querySelector('[data-toast-target="alertMessage"]')
  
  const isAlert = type === "alert"
  if (noticeSection) noticeSection.classList.toggle("hidden", isAlert)
  if (alertSection) alertSection.classList.toggle("hidden", !isAlert)

  if (isAlert) {
    if (alertMessage) alertMessage.textContent = message
  } else {
    if (noticeMessage) noticeMessage.textContent = message
  }

  container.classList.remove("hidden", "translate-x-full", "opacity-0")
  container.classList.add("translate-x-0", "opacity-100")

  hideTimeout = setTimeout(() => {
    container.classList.remove("translate-x-0", "opacity-100")
    container.classList.add("translate-x-full", "opacity-0")
    removeTimeout = setTimeout(() => {
      container.classList.add("hidden")
    }, ANIMATION_DURATION)
  }, HIDE_DELAY)
}
